export default __webpack_public_path__ + "static/media/scotiabank.9d41971d.png";